import { Component, OnInit, Input, ChangeDetectionStrategy, EventEmitter, Output } from '@angular/core';
import { DomainService } from 'app/core/services/domain.service';
import { CardConfiguration } from 'app/core/components/workflow-new/course/configurations/card-configuration';
import { CardConfigurationService } from 'app/core/components/workflow-new/course/configurations/card-configuration.service';

@Component({
  selector: 'itpx-course-card-container',
  templateUrl: './course-card-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CourseCardContainerComponent implements OnInit {
  @Input() platformClass: any;
  @Output() stateChange$ = new EventEmitter<string>();
  private conf: CardConfiguration;

  constructor(
    private domainService: DomainService,
    private cardConfiguration: CardConfigurationService) { }

  ngOnInit() {
    this.conf = this.cardConfiguration.getConf(this.platformClass);
    // console.log(this.conf);
  }
  
  onStateChange(event: any) {
    this.stateChange$.emit(event);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/course/course-card-container/course-card-container.component.ts